export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/BagIcon.047970d5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};